import { BUCKET_API_SERVER } from '../util/constants'


// frame history for back analysis
//
export var HISTORY = []; 	// store player and soccer ball movement history
export var CONSLOG = ""; 	// store console.log for debugging

// All global constants
//
export var CONSTS = {
	AXOS_DATA_VERSION: 0.1,	// to detect major chgs
	// constant for exponential curve smoothing, LOWER the more SMOOTHER and more LAG (loose info)
	EXPON_CONE_DY: 0.8,		// sample of Y pixel above cone
    EXPON_POSE_FEMUR: 0.15,  // need accurate femur reading, delay is OK
	EXPON_TRB_DEGREE: 0.4,	// trail ball degree
	EXPON_TRP_DEGREE: 0.4,	// trail pose degree
	EXPON_BALL_CTRX: 0.5,
	EXPON_BALL_CTRY: 0.5,
	EXPON_POSE_CTRX: 0.5,
	EXPON_POSE_CTRY: 0.3,	// choppy Y is bad news, it scales
	EXPON_POSE_TSPEED: 0.15,	// TRAIL: smooth out more, delay is OK  // 0.2
	//EXPON_POSE_BSPEED: 0.25,	// BODY: just filter out spikes, need min delay // 0.25
	EXPON_BALL_SPEED: 0.6,	// smooth out more, delay is OK
	EXPON_LIMB_DEG: 0.4,	// limb change degree
    EXPON_DEFENDER_SPEED: 0.2,      // defender movement instant speed (need <.3)
    EXPON_DEFENDER_TARGET_SPEED: 0.3,      // defender speed from Turn (need <.4)
    EXPON_TOP_Y: 0.3,       // pose top y posn
    EXPON_BOT_Y: 0.3,       // pose bottom y posn
    EXPON_POSEY_MOVE: 0.5,      // Y movement for adjust camera, not too fast

    // see calcPoseSpeedExpon()
	EXPON_POSE_BSPEED0: 0.90,   	// BODY: less filter for low FPS (10 FPS)
	EXPON_POSE_BSPEED1: 0.80,   	// BODY: less filter for low FPS (10 FPS)
	EXPON_POSE_BSPEED1: 0.75,	    // BODY: more filter/delay for high FPS (20 FPS) to jive with low FPS
	EXPON_POSE_BSPEED2: 0.60,   	// BODY: more filter/delay for high FPS (20 FPS) to jive with low FPS

	EXPON_POSE_BSPEED3: 0.50,   	// BODY: more filter/delay for high FPS (20 FPS) to jive with low FPS
	EXPON_POSE_BSPEED4: 0.20,   	// BODY: more filter/delay for high FPS (20 FPS) to jive with low FPS
	EXPON_POSE_BSPEED5: 0.18,   	// BODY: more filter/delay for high FPS (20 FPS) to jive with low FPS

	EXPON_POSE_BSPEED6: 0.13,   	// BODY: more filter/delay for high FPS (20 FPS) to jive with low FPS
	EXPON_POSE_BSPEED7: 0.13,   	// BODY: more filter/delay for high FPS (20 FPS) to jive with low FPS
	EXPON_POSE_BSPEED8: 0.13,   	// BODY: more filter/delay for high FPS (20 FPS) to jive with low FPS
	EXPON_POSE_BSPEED9: 0.10,   	// BODY: more filter/delay for high FPS (20 FPS) to jive with low FPS
	EXPON_POSE_FPS_SLOW: 10,	    // BODY: target frame rate for slwo device
	EXPON_POSE_FPS_FAST: 20,	    // BODY: target frame rate for fast device, quantize to step of 5?
	EXPON_POSE_FPS_STEPS: 3,	    // BODY: quantize to maintain stability

    // display colors
    COLOR_FACE_MASK: '#b7b5a3b0',       // player face mask  // b7b5a3dd,
    COLOR_SKELETON_MAIN: '#42b21810',   // #42b21840
    COLOR_SKELETON_YOLO: 'rgba(0,255,255,1)',
    COLOR_SKELETON_DEV: 'rgba(0,255,0,1)',
    COLOR_STATS_BACKGROUND: "#88888870",

	// speed ribbon params
	PDEGREE_DELTA_THRESHOLD: 90,		// OBSOLETE: degree chg to become a body turn
	BDEGREE_DELTA_THRESHOLD: 40,		// OBSOLETE: degree chg to become a ball turn
	POSE_SPEED_RIBBON_WIDTH: 10,
	BALL_SPEED_RIBBON_WIDTH: 4,
	TRAIL_LENGTH: 10,
	TRAIL_MIN_SPEED: 4,					// min speed after signal to considered moving

	// femur default seed
	FEMUR_PIXEL_RATIO_SEED: 0.9,	// global: slope of D-femur v D-Y, use to calc depth
	FEMUR_RATIO_Y_SEED: 50,			// global: slope of D-femur v D-Y, use to calc depth
	FEMUR_REF_SEED: 34,				// global: reference femur length at ref_y
	FEMUR_REF_Y_SEED: 100,			// global: reference Y location where the pixel_ratio is valid
    FEMUR_AVG_M: 0.40,  //0.41,     // global: 40cm maps to 5'3" height, lowest err rate in this range
    FEMUR_BODY_RATIO: 0.25,  //0.257,   // global: femur bone to body, female: 0.25, male: 0.257
    FEMUR_MAX_DIFF_VARIANCE: 0.20,       // % chg from the average, to filter out bad femur
    //FEMUR_MAX_SAME_VARIANCE: 0.10,       // % chg from the average, to filter out bad femur
    FEMUR_MAX_BAD: 20,               // max bad femur reading before a reset, usually camera moved

	// movement detect params
	GOAL_MAX_DIST_MATCH: 28,			// KEY: *** max pixel distance considered to reach goal (need to scale!)  // 18
	GOAL_REVIEW_DIST_MATCH: 40,			// KEY: *** max pixel distance goal during turn-review (need to scale!)
	GOAL_REVIEW_CNT_THRESHOLD: 2,		// KEY: *** during review, consequitive reached for a dir chg
	BALL_REVERSE_CNT_THRESHOLD: 1,		// KEY: *** consequitive further away b4 a dir chg
	GOAL_XMATCH_SCREEN_PCT: 30,			// KEY: *** goal "reached" zone: 1 / X of the screen width
	GOAL_YMATCH_SCREEN_PCT: 10,			// KEY: *** untested for diff screen sizes	// 15 not good
	GOAL_REVIEW_TIME_THRESHOLD: 350,	// Do not review goal before X msec after a new session    // 250
	GOAL_REVIEW_HIDX: 3,				// turn-review window to see if we missed a goal after a turn
	BALL_MIN_TARGET_DISTANCE: 25,		// in pix, filter out slow idle movement from turn count  // 20
	GOAL_HEAD_ACCURACY: 65,				// % probabilty of pose head and eyes to consider the head to be "found"
	GOAL_FEET_ACCURACY: 70,				// % probabilty of pose ankle to consider the feet to be "found"
	GOAL_MIN_MAIN_REPEAT: 1,			// repeat observation to make sure it's true	// 3
	GOAL_MIN_PHANTOM_REPEAT: 1,			// repeat observation for phantom, need fewer
	PERF_OUTLIER_RANGE: 0.3,			// acceptable percentage range for final performance data (remove 2sig)
	TURN_ANCHOR_DEGREE_DELTA: 30,		// KEY: *** in degrees, the max +/- tolerance from 180 to detect first anchor (was 30)
	TURN_MAX_DEGREE_DELTA: 60,			// KEY: *** in degrees, the max +/- tolerance from 180 to detect practice loops (was 60)
	TURN_MIN_LOOP_TRAVEL: 30,			// NEED DYNAMINC? min pixels traveled since last turn, not a loop if too short      // 25, 20, 30, 35
	TURN_MIN_ANCHOR_TIME: 500,			// in mseconds, time duration of when an achor can be detected, to weed out jitters (was 600)
	TURN_MIN_TRAVEL_TIME: 800,			// in mseconds, time duration since last turn, to weed out jitters (was 800)
	MIN_AI_MODE_SPEED: 140,				// min CPU speed to run AI models, laptop Envy is about 800

	// cone calibration params
	FOOT_CALIB_SIZEX: 23,       // 25,
	FOOT_CALIB_SIZEY: 13,       // 15,

	// cone detection params
	CONES_REGULAR_REMOVE_THRESHOLD: 10,		// number of time before remove
	CONES_VALID_REMOVE_THRESHOLD: 20,		// number of time before remove
	CONES_VERIFIED_REMOVE_THRESHOLD: 80,	// number of time before remove
	CONES_MAX_POSITIVE: 50,					// cap this so a cone can be removed

	CONES_MAX_NO_CONE_FRAME: 3,			// if no cones then create fake cones, also caps it // 30, 10, 3
	CONE_MIN_INTER_DISTANCE: 35,			// detect dups, in pix
	CONES_ACCEPT_THRESHOLD: 3,				// min rounds to mark a cone as valid	// 18, 12, 5
	CONES_VERIFY_THRESHOLD: 2,				// tolerance to verify cone		// 4, 3
	CONES_VERIFY_DELTA_X: 22,				// px tolerance to verify   // 8, 10, 12, 18

	// cone dedup params
	CONES_DETECT_DELTA_X: 14,				// tolerance to be same cone  // 14
	CONES_DETECT_DELTA_Y: 14,				// tolerance to be same cone
	CONES_DETECT_DELTA_WIDTH: 12,			// tolerance to be same cone  // 12
	CONES_DETECT_DELTA_HEIGHT: 12,			// tolerance to be same cone
	CONES_STATUS_BORDER_PIXEL: 1,			// for displaying active cone
	CONE_MAX_DISTANCE_FACTOR: 1.18,			// if twice the avg of group, then don't include
	CONE_IMAGE_TOP_MARGINY_PCT: 0.3,		// % of screen border unusable for cones
	CONE_IMAGE_BOT_MARGINY_PCT: 0.9,		// % of screen border unusable for cones
	CONE_IMAGE_MARGINX_PCT: 0.2,
	//CONE_PHANTOM_DIST_PCT: 0.5,			// REPLACE WITH FEMUR!!!  % distance to place phantom between home and target  // 0.4
	CONES_MIN_STARTING_CONES: 2,			// *** less than 3 real cones then we use fake cones

	// time delay params
	CONES_RESULT_ERROR_MSDELAY: 150,	    // milisecs to show the result      // 8000
	CONES_RESULT_DISPLAY_MSDELAY: 8000,	    // milisecs to show the result      // 8000
	CONES_RESULT_PROCEED_MSDELAY: 6000,	    // milisecs to show the result      // 8000
	CONES_SHORT_DISPLAY_MSDELAY: 3000,	    // milisecs to show the result
	CONES_STOP_SESSION_MSDELAY: 6000,		// milisecs to detect a stop session
	SESSION_RESTART_MSDELAY: 10000,			// milisecs before new session can start
    SPLASH_DISPLAY_DELAY: 5000,             // msec, 3500
    AUTH_DISPLAY_DELAY: 1000,               // msec
    CONES_RESULT_DISPLAY_DELAY: 1000,       // display end result
    AUTH_CHECK_DELAY: 8000,                 // msec wait before checking auth response
    BOT_SLAVE_CHECK_INTERVAL: 10000,        // every 15 minutes

    // bot remote control related
    BOT_DRILL_START_HASH: "_start-sync-session_",
    BOT_DRILL_END_HASH: "_end-sync-session_",
    BOT_DRILL_MATCH_ALL: "_all_",

    // mock (simulation) related
    MOCK_DISPLAY_TIMER: 2000,               // 1500, timer count down - to decide action
    MOCK_PRESTART_DELAY: 300,                // slight delay before starting mock session
    MOCK_START_DELAY: 1000,                // 1600, 1200, pause before starting next session
    MOCK_START_RAMP: 500,                 // play slow motion
    MOCK_START_MEASURE_DELAY_SEC: 0.02,           // short delay to allow video to go
    MOCK_LOADING_DELAY_SEC: 0.2,                // arbitrary player loading delay for timer mode
    MOCK_DISPLAY_BEFORE_SEC: 2,             // in seconds
    MOCK_DISPLAY_AFTER_SEC: 1,             // in seconds
    MOCK_ADVANCE_CLICK_SEC: 0,            // OFF: allow click B4 ball is kicked, not too much
    MOCK_DISPLAY_PREVIEW: 2000,             // display footage before the detect
    MOCK_DISPLAY_REFRESH: 200,              // update annotation display
    MOCK_DISPLAY_END: 2500,               // pause at the end
    MOCK_DISPLAY_LABEL: 300,              // update annotation display
    MOCK_DISPLAY_GREEN: -150,              // yellow turns green for "go"
    MOCK_DISPLAY_BASE: -700,                // amount time a label stays on the screen (msec) MOCK_DISPLAY_LABEL: 1000,                // amount time a label stays on the screen (msec)
    MOCK_PLAYER_SPEEDS: [0.25, 0.5, 1.0, 1.5, 2.0], // speed points for testing
    MOCK_TYPES: ["target", "path", "passing", "position", "comment"],      // modes 
    MOCK_TYPE_TITLES: {"comment": "PLAYER REACTION TIME",
                        "target": "SELECT PASSING TARGET", 
                        "path": "IDENTIFY BEST PATH",
                        "position": "IDENTIFY POSITIONING ISSUE",
                        "passing": "IDENTIFY TARGET POSITION"},


    // canvas display params
    DISPLAY_BASE_X: 470,                    // base width to calc font size scale
    DISPLAY_BASE_Y: 260,                    // base width to calc font size scale
    WEBCAM_BASE_ASPECT: 1.85,           // (width / ht) for display scaling factor, was 360, 320, 640    x1.77
    WEBCAM_BASE_HEIGHT: 270,          // for display scaling factor, was 270, 240, 360    x1.33
    WEBCAM_BASE_WIDTH_FN: () => { return parseInt(CONSTS.WEBCAM_BASE_ASPECT * CONSTS.WEBCAM_BASE_HEIGHT)},

	// home command param
	HOME_SPECIAL_ID: "HOME",				// for id cancel event
	HOME_CANCEL_THRESHOLD: 885,				// staying at home to cancel testing    85
	HOME_WARNING_THRESHOLD: 865,			// staying at home to cancel testing    65
	HOME_COOLDOWN_THRESHOLD: -30,			// wait before it can re-enable
	REACTION_MIN_DIST_PCT: 0.8,				// percentage travels towards goal to consider "reacted"
	HOME_XSIZE: 35,							// home zone ellipse size
	HOME_YSIZE: 18,
	HOME_MIN_YOFFSET: 40,					// in case of a 2 cone config, set the home back a little (chg is 1/2)

	// session run control params
	//PERF_RUN_COUNT: 10,						// *** number of runs per session
	FAKE_CONE_CONFIG: 2,					// *** type of fake cone config (2, 4)
	CALIBRATION_CONE_NEED: 1,				// *** for 4 cones, we need 2 (kitty coners), for 2 cone we need just 1

    // drill history related
    HISTORY_MAX_READ: 1000,         // max entries returned
    //HISTORY_MIN_SAMPLE: 4,          // SERVER: min data samples for record considation, need to be reproduceable
    //HISTORY_MIN_TT0: 45,            // SERVER: KLUDGE: min total duration for TT0, could be fewer count?

	// finger game params
	GAME_MAX_WAIT_MSEC: 800,		// wait time before showing next target
	GAME_MIN_WAIT_MSEC: 200,		// min wait time before showing next target
	GAME_SCREEN_MARGINX: 60,		// stay away from edge of screen
	GAME_SCREEN_MARGINY: 40,		// stay away form edge of screen
	GAME_TARGET_SIZE: 60,			// size of the circle
	GAME_SLOW_TARGET_MULTIPLIER: 1.2,	// target detect size adjust, the bigger the easier to hit
	GAME_FAST_TARGET_MULTIPLIER: 1.8,	// target detect size adjust, the bigger the easier to hit
	GAME_MIN_ACCURACY: 31,			// below this % and the run does not count
	GAME_MIN_VALID_DATA: 5,			// below this cnt the run is not repeatable and doesn't count
	//GAME_MAX_CNT: 10,				// wait time before showing next target

	// defender bot
    DEFENDER_COGNITON_DELAY: 250,     // cognition delay (msec)  defend_cog: [ slow=300, avg=250, ]
    DEFENDER_ACCELERATION: 2.3,        // meter / second         defend_acc: [ slow=200, avg=300, ]
    DEFENDER_GIVE_UP_GAP_PCT: 15,          // screen pct (100), stop defend_gap: [ slow=20, avg=15, fast=10 ] 
    DEFENDER_FOLLOW_ACCURACY: 50,     // out of 100, follow fidelity (100 is "like glue")
    DEFENDER_PLAYER_MIN_SPEED: 0.8,   // min player moving speed (f/s) for defender to give up     // 1.1
    DEFENDER_JUKE_MIN_SPEED: 1.2,     // min defender moving speed (f/s) for defender to give up     // 1.1
    DEFENDER_Y_OFFSET_PCT: 5,           // pct (100), shift defender lower on screen
    DEFENDER_Y_DRIFT_MAX_PCT: 7,       // max drift pct (100) of INFO.image_height
    DEFENDER_X_DRIFT_MAX_PCT: 8,       // max drift pct (100) of INFO.image_width
    DEFENDER_Y_DRIFT_HIDX: 40,          // frames to do the Y drift
    DEFENDER_X_DRIFT_HIDX: 30,          // frames to do the Y drift
    DEFENDER_DEFAULT_TIME: 8,       // seconds - 10 secs to beat the bot
    DEFENDER_RECOVER_MSEC: 500,       // msec - bot recovery time after defeat
    //DEFENDER_X_JITTER_PCT: 3,           // random sideway jitters pct (100), make it look more dynamic


    // misc constants
    EPOCH_DEFAULT_TZ: 7,                // KLUDGE: default timezone (in hours) to PST
    EPOCH_1970_WEEK_DAY_OFFSET: 4,      // Offset Day of week on epoch (1970/1/1)
    EPOCH_MSEC_IN_A_DAY: 8.64e7,        // used for day calc

    // drill star display
    TWO_STAR_MIN_PCT: 0.05,
    ONE_STAR_MIN_PCT: 0.10,

    // pwa states
    PWA_USE_SAFARI: "use_safari",
    PWA_ADD_IOS_HOME: "add_ios_home",
    PWA_ADD_ANDROID_HOME: "add_android_home",
    PWA_NO_CHANGE: "no_change",

	// misc params
	DEMO_UID: "XEr6e3WygmVdXgzPTBrZe7h9vT12",	// CANNED DEMO account data for anon user
	DEMO_EMAIL: "soccerball9233@gmail.com",	    // CANNED DEMO account data for anon user
	DEMO_NAME: "Demo User",	                    // CANNED DEMO account data for anon user
	DEMO_AVATAR: "https://firebasestorage.googleapis.com/v0/b/axo-sports.appspot.com/o/trash%2Fmad_headshot.png?alt=media&token=23842c57-e0ac-4b5f-98bc-39910b1b582e",	// CANNED DEMO account data for anon user
	SCREEN_SUPER_WIDE_RATIO: 1.9,	// too wide, need to cap height to 100% and vary width
	//SCREEN_VERTICAL_RATIO: 1.2,		// aspect ratio to be vertical
	//SCREEN_HORIZONTAL_RATIO: 1.0,	// aspect ratio to be horizontal
	SCREEN_HORIZONTAL_RATIO: 0.85,	// aspect ratio to be horizontal
	SCREEN_SUPER_NARROW_RATIO: 0.5,	// too narrow, need to cap width to 100% and reduce height
	GOBACK_BAR_HEIGHT: 0,           // for offset, in pixel, top title bar, DISABLED: added margin to top container     // was 50
	GOBACK_BAR_HEIGHT1: 50,         // for height, in pixel, top title bar, DISABLED: added margin to top container
	SIDEBAR_SMALL_WIDTH: 200,		// in pixel, small <Result> to maximize video window
	SIDEBAR_BIG_RATIO: 0.8,			// 0.6  in %, the percent of screen use for sidebar practice video
	SIDEBAR_HEIGHT: 400,			// in pixel for vertical mode, mostly for game mode
    REALTIME_CHECK_INTERVAL: 100,   // msec
    DB_RECHECK_INTERVAL: 100,       // INFO.db_* not ready, wait and check again
    MAX_HIGH_SCORE_MULTIPLE: 2,     // for display filter of high scores
	PERF_KEYS: [ "r00", "r01", "r04", "r05", "c01", "c02", ,"c03", "h00", "ss0", "tt0", "t00", "t01", "t05","a00", "a01", "a04", "a05", "d00", "d01" ],	 // **** MUST MATCH STATS!!!!
    SPLASH_ASSET_PATH: BUCKET_API_SERVER + "/bucket/splash/",     // store in the name of invite_key "lfc-demo"
    THUMBNAIL_ASSET_PATH: BUCKET_API_SERVER + "/bucket/thumbnail/",     // store in the name of drill_key "lfc-demo"
    PREVIEW_ASSET_PATH: BUCKET_API_SERVER + "/bucket/preview/",     // store in the name of drill_key "lfc-demo"
    LOGO_ASSET_PATH: BUCKET_API_SERVER + "/bucket/logo/",            // all sorts of logos
    WEB_ASSET_PATH: BUCKET_API_SERVER + "/bucket/web/",              // all web assets here, instead of doing a release
    DEFAULT_CHAIN_DELAY: 20,        // seconds, waiting between chained drills


    // FPS RELATED
	MIN_FPS: 5,						// Below this frame rate, skip Yolo ball detection
	VIDEO_RECORD_FPS: 15,			// used to start video.captureStre()
    MAX_ANIMATION_MSEC: 45,    //45,         // Do not run AI frames faster than this (50 msec == 20 FPS)
    MIN_SPEED_READ_MSEC: 400,       // min time period to calculate speed, to normalize speed reading over all sample rates (expon related)

    // KLUDGE params
    YOUTUBE_VERTICAL_KLDUGE: 400,   // KLUDGE: pad top and bottom of the "ouput" so the "play next" does not show, ONLY for youtube video (not webcam)
    GOBACK_BUTTON_KLUDGE: 800,      // KLUDGE: goback has some weird delay, so disable it a bit to tell user (remove when fix the bug)
    //KLUDGE_BIG_DELAY: 200000000,     // KLUDGE: big delay to allow debug
    KLUDGE_BIG_DELAY: 99995000,     // KLUDGE: big delay to allow debug


	FORCE_NO_BALL_DETECT: true,		// if set, turn off ball AI to speed things up
	PERF_RUN_COUNT: 10,				// DEBUG:  *** number of runs per session	// 10
	GAME_MAX_CNT: 15,				// number of repeat trials		// 15
	MOCK_MAX_CNT: 15,				// number of repeat trials		// 15

    ANON_PLACEHOLDER_ID: "anon_placeholder",      // kludge fb_id to create temp user
    
    // angle constants
    LIMBS_NAME: ["TL", "TR", "BL", "BR", "CH", "CB"],
    MEMBS_NAME: ["LARM", "LFAM", "RARM", "RFAM", "LTHG", "LLEG", "RTHG", "RLEG", "CHED", "CBOD"],
	LIMB_MAX_SAME_POSE: 2,				// detect as a turn signal if holding too long   10, 4

    // sound files:    
    // src: https://freesound.org/
    // tool: https://www.freeconvert.com/wav-to-mp3
    //
    MAN_HEY_PATH: "sounds/man-hey.mp3",                 //
    SOFT_HEY_PATH: "sounds/soft-hey.mp3",               // 
    CHIME_PATH: "sounds/chime.mp3",                     // for one loop completion (short)
    UPLIFT_BELLS_PATH: "sounds/uplift-bells.mp3",       // for session change (subway like)
    TWO_TONE_CHIME_PATH: "sounds/two-tone-chime.mp3",   // for session start, end, (long)
    FINISH_BEEP_PATH: "sounds/finish-beep.mp3",         // for final finish (long)
    HAPPY_RING_PATH: "sounds/happy-ring.mp3",           // for total completion (long)
    HAPPY_BEEP_PATH: "sounds/happy-beep.mp3",           // for middle success (short)

    RELAX_CHIME_PATH: "sounds/relax-chime.mp3",         // for minor progress (short, high)
    SUB_PING_PATH: "sounds/sub-ping.mp3",               // for minor progress (short, high)
    BONG_PATH: "sounds/bong.mp3",                       // for minor progress (short, low)
    BOUNCE_PATH: "sounds/bounce.mp3",                   // for mid-switching goal (short, low)
    SKID_PATH: "sounds/skid.mp3",                       // for mid-switching goal (mid, low)
    BUZZZER_PATH: "sounds/buzzer.mp3",                  // for trial mishap (short, high)
    COWBELL_THUD_PATH: "sounds/cowbell-thud.mp3",       // for minor notice (short, low)

    ALERT_DING_PATH: "sounds/alert-ding.mp3",           // for warning (mid, high)
    CENSOR_BEEP_PATH: "sounds/censor-beep.mp3",         // for warning (mid, high)
    LOW_C_PATH: "sounds/low-c.mp3",                     // for warning (long, low)
    FAIL_LOW_PATH: "sounds/fail-low.mp3",               // for major failure (long, low)
    FAIL_CRACKLE_PATH: "sounds/fail-crackle.mp3",       // for major failure (short, low)
    //SERVER_VERSION_PATH: "version"                      // latest version from server static file

    get SESSION_COMPLETE_PATH() { return this.TWO_TONE_CHIME_PATH },
    get CONFIG_LOADED_PATH() { return this.HAPPY_RING_PATH },
    get NEW_USER_START_PATH() { return this.UPLIFT_BELLS_PATH },
    get SWITCH_GOAL_PATH() { return this.SKID_PATH },
    get START_RUN_PATH() { return this.TWO_TONE_CHIME_PATH },
    get MINOR_PROGRESS_PATH() { return this.SUB_PING_PATH },
    get REP_SUCCESSS_PATH() { return this.CHIME_PATH },
    get REP_FAIL_PATH() { return this.FAIL_LOW_PATH },
    get REACHED_HOME_PATH() { return this.BUZZZER_PATH },
    get SESSION_ABORT_PATH() { return this.COWBELL_THUD_PATH },
    get SESSION_END_PATH() { return this.FINISH_BEEP_PATH },
    get SYSTEM_ABORT_PATH() { return this.FAIL_CRACKLE_PATH },
    get UNKNOWN_STATE_PATH() { return this.CENSOR_BEEP_PATH },
    //get SERVER_VERSION() { return this.SERVER_VERSION_PATH },

    // cookies
    COOKIE_ID_TOKEN: "id_token",
    COOKIE_EMAIL: "id_email",
    COOKIE_USER: "id_user",
    COOKIE_FB_UID: "id_uid",
    COOKIE_SPLASH: "id_splash",
    COOKIE_LOGIN_COUNT: "id_login_count",
    COOKIE_AVATAR: "id_avatar",
    COOKIE_UID: "uid",
    COOKIE_HAS_LOGIN: "id_has_login",
    COOKIE_INVITE: "id_invite",
    COOKIE_TEMP_UID: "id_temp_uid",
    COOKIE_AUTHED: "id_authed",
    COOKIE_STARTING_URL: "id_start_url",
    COOKIE_INIT_VISIT: "id_init_visit",
    COOKIE_SEARCH: "id_url_search",
    COOKIE_PATH: "id_url_path",
    COOKIE_CHAIN_MODE: "id_chain_mode",
    COOKIE_DEBUG_SPLASH: "id_splash_debug",

}


// NEEDED IN REACT COMPONENT DISPLAYS, persistes across modules, access via STATES.*
//
export var REACT_STATES = { 
      authed: false,  		// logged in user
	  has_login: null,		// login data
	  auth_token: null,
	  ai_loading: false,	// flag to prevent double binding call
	  ai_avail: false,		// model is ready

	  session_stopped: false,	// use to turn on <Wait>
	  interrupted: false,	// if session cancelled, do not save
	  adjust_orientation: 0,    // NOTE: react var for orientation adjustment
	  VerticalMode: false,	// try to sync to REACT state, camelCase so not confuse w/ INFO
	  show_redirect: false, 
	  show_progress: true,  // show login progress spinner, need to sort out with INFO
	  //target_path: null,    // for invite redirect
	  //entry_path: null,     // for regular redirect

	  button_text: "",		// start button

	  // display
	  reaction_msec: "",		// last reaction time
	  preaction_msec: "",		// last phantom reaction time
	  rep_cnt: 0,			// number of times in the session
	  speed: 0,

	  // user cred
	  uid: null,			// from firestore auth cred
	  email: null,
	  first_name: null,
	  last_name: null,
	  auth_src: null,
	  photo: null,
	  account_email: null,

    has_news: false,

      // misc
      drill_key: null,      // for youtube direct drill mode
}


// session info states
//
export var INFO = {
	// basic info
	tus_url: null,		// vimeo url for upload session
	setState: null,		// cross over to React side
	State: null,		// cross over to React side

    // user info
	email: "",			// use user email for firestore db lookup
	avatar: null,		// photo for firebase bucket
	uid: null,			// uid for firebase bucket
	user_id: null,		// user key: sanitized user email
	org_key: null,		// org key the user belongs to, affiliated by invite
	login_uid: null,	// uid of original login
	anon_email: "",		// anon: use user email for firestore db lookup
	anon_avatar: null,	// anon: photo for firebase bucket
	anon_uid: null,		// anon: uid for firebase bucket (may dup with temp_uid)
	anon_name: null,		// anon: uid for firebase bucket
    current_user: {},      // analogous to bot_setup.users[] {avatar, email, uid} for chained auto drill
    
    // invite stuff
    invite_key: null,       // passed in as https://axos.cc?i=<invite_key>
    drill_hash: null,       // passed in as https://axos.cc?d=<invite_key>+<drill_key>
    temp_uid: null,         // auto_run_mode: hold temp uid in cookie for repeaters, replace w/ real one later
    splash_image: null,     // use invite_key if invite, otherwise org
    drill: null,            // holds current drill object
    drill_mode: null,       // central place, need to consolidate perf_mode, mock_mode

	// show object setting
	show_calibration_mark: false, 	// display length scale mark
	show_cones: true,  				// display cones
	show_defender: false,   		// use INFO.drill_param1.defender-cog
	show_home_zone: true,   		// display home zone for perf mode
	show_download: false,			// KLUDGE: NEED TO FIX THIS!  when a new sw version is available
	show_login_progress: true,     // show login progress spinner
	show_vconsole: false,			// DEBUG: ****** turn on display format debugging ****
	show_tutorial: true,			// global enable switch
	show_invite: true,			    // always show invite unless already a user
	show_3D: false,			        // show 3D scatter inset, debug via easter egg btn only
	show_no_ai: true,			// only show it once
	show_results: false,		// show final metrics at end of session
    show_stats: true,           // hide normal annotated stats, this is for record intro video
    show_facemask: true,        // shwo pose privacy facemask
    show_skeleton: true,        // shwo AI skeleton
    show_virtual_cones_only: true,      // no physical cones

	// system mode setting
	god_mode: false,				// has ability to assume owned player identities
	admin_mode: false,				// localhost & axos.cc/admin enters admin mode
	anon_mode: false,				// logged in as anonymous user, has crippled capabilities
	adhoc_mode: false,				// logged in as field added adhoc user, do not add to leaderboard
	direct_start_mode: false,		// show youtube drill from url, log in as anonymous user, has crippled capabilities
    auto_run_mode: false,           // auto-start drill from usrl (support direct url links)
    train_model_mode: false,        // run the drill to collect motion marker data
	review_mode: false,				// source from video file (not webcam), re-process HISTORY
	perf_mode: false,				// performance measurement mode
	game_mode: false,				// finger reaction games
	mock_mode: false,				// mock game simulation video, only for running, no edit
	analyze_mode: false,			// reviewing stuff like videos and leader boards
	practice_mode: false,			// turn on webcam and AI, but no sessions or runs (no goals)
    defender_mode: false,           // enable display of auto-defender
	tutorial_mode: false,			// showing a tutorial video
	footage_mode: false,			// in analysis->footage, review game footage and make annotation edits
	exception_mode: false,			// process a crash exception

	logging_mode: false,			// send HISTORY result to firestore at the end of play
	no_ai_mode: false,				// test HTML layout only on emulators, AI disabled
	slow_dev_mode: false,			// too slow, only run pose model, do not detect ball
	interrupted_mode: false,		// op interrupted, do not save
	record_mode: true,				// record video when session is running
        slowmo_mode: false,				// start practice video in slow mo
	vertical_mode: false,			// display mode
	perf_delay_mode: false,			// started a perf run but waiting for delay
	ground_view_mode: false,		// camera placed on the ground: shift cones down

    // REACT VAR CACHE
    catalog_type: null,             // React cache
    countdown_time: null,           // in seconds

    practice_run_mode: null,         // [timer | reps]
    timer_run_duration: null,     // seconds: duration for timer mode
    drill_chain_mode: false,         // auto start next drill after first ended
    drill_chain_delay: null,         // rest delay in seconds
    drill_chain_abort: false,        // aborted by server, reset after receive new command

    // SYSTEM DEBUG override
    enforce_horizontal_mode: true,  // must be horizontal to run AI camera

    // Analyze: Master Slave Bot Control
    bot_master_mode: false,
    bot_slave_mode: false,
    bot_last_msg: null,             // last read (may not be processed)
    bot_stats: null,                // player stats for this run
    bot_all_stats: null,            // all other player stats in this class
    bot_processed_msg: null,        // buffer, last processed
    bot_setup: null,                // buffer
    bot_setup_msg_id: null,         // buffer
    bot_group_id: null,             // buffer
    bot_all_drills: null,           // buffer

    bot_all_prog: null,             // prog sequence, no sync
    bot_orig_active_state: null,           // buffer
    bot_index_override: null,           // buffer
    bot_run_mode: null,             // "prog" means runs thru prog before switch user
    bot_active_user_idx: null,            // current user
    bot_active_device_hash: null,          // current device
    bot_active_class_hash: null,          // current class
    bot_read_from_db: true,          // force reading class student list from db
    bot_create_new_class: false,      // new class or update old one

    bot_active_class_groups: [],
    bot_active_roster_groups: [],
    bot_active_deivce_groups: [],
    bot_active_prog_groups: [],
    bot_active_roster_list: [],
    bot_active_node_list: [],
    bot_active_drill_list: [],
    bot_orig_roster_list: [],
    bot_orig_node_list: [],
    bot_orig_drill_list: [],

    // Defender: Auto dancing partner
    defend_max_dx_psec: null,            // max pixel movement per second, normalized with femur (~200)
    defend_restart_time: null,           // time with cognition delay
    defend_dx_ps: null,                  // most recent dx movment, use during cognition delay 
    defend_gave_up: false,               // stop defender
    defend_cog: null,                    // cognition delay (msec)  defend_cog: [ slow=300, avg=250, ]
    defend_acc: null,                    // accelerate (m/s)      defend_acc: [ slow-1.1,     ]    // slow=200, avg=300, ]
    defend_gap: null,                    // screen pct (100), stop defend_gap: [ slow=20, avg=15, fast=10 ] 
    defend_dy_drift_max: null,           // total limit
    defend_dy_drift: null,               // current
    defend_dx_drift_max: null,           // total limit
    defend_dx_drift: null,               // current
    defend_tot_turns: null,              // turns made on this run
    beat_defender: false,                // global state var
    expon_pose_bspeed: 0.3,              // action.body_speed adaptive expon smoothing (based on FPS), start with neutral


    // Analyze: Developer Analyze mode
    dev_video_stopped: null,        // control dev mode AI analyze using video
    dev_analyze_mode: false,        // for annotateA coloring
    dev_record_mode: null,         // ["none", "ai"]  need to know if we need to call ai in the loop
    dev_webcam_mode: null,         // vs. playing video footage
    dev_recording: null,            // if recoding is running
    dev_ai_running: null,            // if AI is running
    TL_state: true,                 // limb selection state
    TR_state: true,                 // limb selection state
    BL_state: false,                 // limb selection state
    BR_state: false,                 // limb selection state
    CH_state: false,                 // limb selection state
    CB_state: false,                 // limb selection state

	// current operation setting
	perf_running: false, 			// perf measurement is running
	game_running: false, 			// game is active
	mock_running: false, 			// simulation is active
	record_running: false, 			// video saving is running
	phantom_running: false, 		// player is executing a phantom redirect
	defender_running: false, 		    // defender mode active
	reps_running: false, 			// practice in process, count each rep
    webcam_started: false,          // start cmd issued
    webcam_running: false,          // webcam actively running, used in videoUtil
    drill_running: false,           // replace DrillActive
    chain_running: false,           // this is true if we are in wait mode and drill not running
    video_stopped: true,            // used in videoUtil

    // kludge factors: not clean but needed
    kludge_youtube_height: 0,   // to hide the "play next" forced on us by google


    // session info
	session_name: "no_name_yet",			// name of the perf or practice session
	drill_hash: null,			// name of the perf or practice hash
	seq_hash: null,			// name of the perf or practice hash
    tut_module: null,          // nav: where we are, use this for tutorial
    tut_op: null,              // nav: current op, use this for tutorial
	session_completed: false,	// true if all the reps are done properly and pass quality bar
    db_store_started: null,     // start of db write
    db_store_completed: null,   // all db write is done, reset when start a new drill

    // db cached info
    menu_data: null,            // relevant raw menu db records
    menu_keys: null,            // processed display keys  {top: ["m1.key", "m2.key+sub", "m3.key"], m2: ["m4", "m5+sub"], m5: ["m6", "m7"]}

	// immutable persistent states 
	svg: null,					// for graph charts
	webcam: null,				// link to camera object
    audio: null,                // link to audio, created on first click
	stream: null,				// webcam video stream object, for teardown
	ip_info: {},				// user IP info
	user_agent: null,			// browser agent string for stats
	device_str: null,			// player device used for this session
	browser_str: null,			// browser to figure out PWA stuff
	device: null,			    // object version, easy access
	browser: null,			    // object version, easy access
	axos_version: null,			// AXOS version used for this session
	user_location: null,		// extracted location info from IP
	video_format: null,			// format of video out
	video_codec: null,			// format of video out
	server_axos_version: null,	// Current SERVER AXOS version, determines if update needed
    localhost: false,            // true if running on localhost
    starting_url: null,         // incoming url
    idx: [],                    // the keypoint feature translation, movenet has 17, blazepose has 33

	file_list: "default",		// processed file list
	file_name: "default",		// processed file
	recording_file: null,		// file name being recorded
	analysis_canvas: "output",	// canvas for analysis, vcanvas  // yolo, output
	output_canvas: "output",	// final output canvas to display skeleton  // yolo, output
	bug_report: "",				// keep user bug report here
    footprint_shape: null,      // holds Image element

	// misc config modes
	skip_ball_detect: true,		// Too slow, do not detect ball AI
	use_camera_object: false,		// TEST ONLY: use cameraClass() demo code to figure out skeleton offset
	use_movenet: false,			// pose estimation use new moveNet instead of poseNet
	use_blazepose: true,		// pose estimation use new moveNet instead of poseNet
	use_media_pipe: true,		// two versions of blazepose: media_pipe & tfjs - on IOS use tfjs, otherwise use mediapipe
	//use_media_pipe: false,		// two versions of blazepose: media_pipe & tfjs
    redirect_path: null,        // where to go after auth
    gesture_allowed: false,     // enable gesture control
    last_gesture_time: 0,       // temporary state to prevent gesture congestion
    input: {},                  // keyboard input butter

    override: {
        disable_catalog_swipe: false,   // disable catalog touch when in <Game>
        show_grid: false,        // show grid in perf canvas
        show_ratio: false,        // show pose ratio for camera detection
        show_ht: false,           // show player height calibration bar with inches

    },

    // diagnostic states
    current_fps: 0,             // frame rate
    check_realtime_start: null,     // start of real time response check
    last_realtime_fault: 0,      // start of real time response check
    realtime_fault_count: 0,     // total faults

    // formatting states
    annotate: null,             // holds annotate object
	out_canvas: null,			// buffer canvas element (avoid passing in)
	out_context: null,			// buffer context element (avoid passing in)
	prime_context: null,		// primary context for display (avoid flicker)
	prime_canvas: null,		    // primary context for display (avoid flicker)

    image_width: null,			// canvas size, differ based on src (webcam, vid file)
    image_height: null,
    pose_img_ratio: null,
    yolo_img_ratio: null,
	webcam_owidth: null,		// orig webcam aspect ratio, this chgs later
	webcam_oheight: null,		// orig webcam aspect ratio, this chgs later
	webcam_aspect: null,		// orig webcam aspect ratio, wd / ht
	video_owidth: null,			// orig video file aspect ratio, this chgs later
	video_oheight: null,		// orig video file aspect ratio, this chgs later
	video_aspect: null,			// orig video file aspect ratio, wd / ht
	//vimeo_player: null,			// pointer to vimeo player in <Learn>
	mock_player: null,			// pointer to vimeo player in <Mock>
	learn_player: null,			// pointer to abstract player in <Learn>
	vimeo_skim: null,			// current skim position
	vimeo_link: null,			// link to newly created vimeo file
    //video_id: null,             // vimeo or youtube id
    //video_start: null,          // start time in seconds
    //video_end: null,            // end time in seconds
    youtube_player: false,      // [boolean] supports "youtube extra height" workaround, set in Learn:Selected
    yt_video_player: null,      // NOTE: need to be global so accessible in callbacks!
    vm_video_player: null,
    video_play_secs: null,      // how long to play before interrupt
    video_start: 0,          // temp var for calllout
    video_end: 0,          // temp var for calllout
    video_width: 0,          // temp var for calllout
    video_height: 0,          // temp var for calllout
    video_timer: null,          // temp var for calllout
    video_url: null,          // temp var for calllout
    footage_width: 0,          // temp var for calllout:  NEED TO DEDUP THIS against video_height
    footage_height: 0,          // temp var for calllout
    webcam_stream: null,        // hold stream

	sidebar_height: CONSTS.SIDEBAR_HEIGHT1,	// pixel of <Results> sidebar
	scale_factor: null,		    // use this to enlarge object based on screen size (replace by scale_x?)
	scale_x: null,		        // for annotation X placement:  1X is 360,
	scale_y: null,		        //for annotation X placement:  1X is 270, 
	scale_font: null,		    //for annotation font sizing:  1X is 360x270, 
	scale_dist: null,		    //for distance scaling
    max_sidebar: false,         // replaces INFO.max_sidebar

	// scratch pad vars (persistent across React modules)
    last_hidx: null,            // these are non-significant states
    last_video_time: null,      // for not run ai if video is paused    
    last_analysis_hidx: null,       // to prevent dup frame processing

	// K-NN for drill loop detection
    knn_master_enable: true,         // master control
    knn_markers: [],            // working k-nn reference markers (object) for this drill
    knn_gestures: [],           // final detected gestures
    knn_gestures_history: [],           // final detected gestures
    knn_token_dictionary: [],   // master dictionary of frequently use tokens for this drill, copied to knn_markers[]
    knn_drill_tokens: [],       // store k-nn reference tokens (string) for this drill, token = [[a, b], [c]]
    knn_static_tokens: {},      // store k-nn reference tokens for gesture detection, token = [LRAISE: [a, b], RRAISE: [c, d]]
    knn_player_markers: [],     // need to reset at top of each AI run;
    knn_scores: [],             // store k-nn reference markers (object) for this drill, score = [42, 34]

    knn_last_gesture: null,     // TMP: time of last processed gesture
    knn_last_gesture_idx: 0,
    knn_last_marker: 0,         // TMP: used to track the last processed marker
    knn_last_rep_marker: 0,         // TMP: used to track the last processed marker
    knn_debug_mode: false,      // show detailed marker trace
    knn_reset_mode: true,      // reset knn state when starting
    detection_mark: [],        // time annotation to assist AI
    current_hidx: null,         // make hidx avail to keydown


	// temp operational states
	session_timestamp: null,	// most recent session being written
	drill_tot_set_cnt: null,		// number of practice sets to complete
	drill_tot_rep_cnt: null,		// number of practice reps to complete
	drill_set_cnt: null,		// number of practice sets completed
	practice_tot_rep: null,		// total number of rep
	practice_degree_log: [],	// last degree at turn
	practice_turn_idx1: null,	// index of first half turn, use to compare degree and dist
	practice_turn_idx2: null,	// index of second half turn, use to compare degree and dist
    heads_up_frames: null,       // count the frames with player head facing up (for h00 calc) - uses valid_frames
    valid_frames: null,         // valid practice frames to check for heads up %
	notify_messages: [],		// summary display on video canvas
	notify_message1: "",		// in video canvas message
	notify_message2: "",		// in video canvas message
	notify_title: "",		    // title in video canvas message
    progress_message: "",       // while waiting, allow lower level to pass up info for user
    display_time_cnt: null,       // timer mode: time counts left for displayRepsLeft()
    display_rep_cnt: null,        // rep mode: rep counts left for displayRepsLeft()
    display_rep_color: null,    // rep count color
	notify_color: null,			// in video canvas message color
	notify_size: null,			// in video canvas font size, default 28, smaller is bigger
	animation_id: null,			// for cancelling requestAnimationFrame()
	warning_message: null,		// warning msg of <Notice> alert from low level
    auto_completed: false,      // if player finished the set
    summary_created: false,     // semaphore to prevent repeat
    easter_egg: [],             // track left-right sequences to unlock stuff
    easter_text: null,          // message to send to user
	health_light_color: "#fff",	// health light color: driven by real time delay
    refresh_cnt: 0,             // use for event handlers to trigger a React refresh
    preflight_target: 0,        // to achieve next personal record
    preflight_limit: 0,         // if exceed this, it's prob not valid data
    personal_record: {},        // the personal record for this drill
    world_record: {},           // the world record for this drill
    practice_start_x: null,     // starting practice position
    practice_start_y: null,     // starting practice position
    drill_stars: 0,             // show the stars for each run to motivate
    making_drill: false,        // for creating new drill
    pwa_showed: false,          // don't show pwa notice too many times
    run_action: null,           // equivalent to RunAction to be used from timeout

    last_traveled: null,       // perf: phantom goal dist to compare, needs to be positive
    last_traveled_delta: null,   // perf: phantom goal direction to compare, needs to be positive
    last_traveled_plus: null,   // perf: phantom goal direction to compare, needs to be positive
    last_traveled_minus: null,   // perf: phantom goal direction to compare, needs to be positive
    pose_reverse: false,        // KLUDGE: if this hidx pose is reverse direction


    // db cache
    db_today: null,         // store a copy of today drills from db (merged progs)
    db_org: null,           // user home org, get branding from here
    db_contents: null,      // contents like tutorial assets
    db_menus: null,         // all drills qualified by user
    db_sections: null,      // all drills qualified by user
    db_drills: null,        // all drills qualified by user
    db_motions: null,       // finger game motions
    db_states: null,        // tutorial & other states
    db_tutorials: null,     // tutorial read states
    db_leaders: null,       // leader boards
    db_scores: null,        // daily scores
    db_players: null,       // for god mode
    db_news: null,          // for news items
    god_players: null,      // for god mode
    current_score: null,    // latest player score
    has_user_state: false,  // if <Learn> starts later, check this first
    active_drill: null,     // hold active drill
    splash: null,           // hold splash content objects (can be multiple pages)
    all_today: null,        // ready-to-use today seq

	// misc record keeping
	media_recorder: null,	// webcam media recorder
	service_worker: null,	// handle to the active service worker, use this to postMessage();
	pose_model: null,		// pose AI model entry point (have have dupes)
	ball_model: null,		// ball AI model entry point
	model_promise: null,	// in case loadAIModel() happend b4 login
    landmark_url: null,     // blazePose 3D data
    scatter_model_init: false,      // for 3D visualizatino debug
    conseq_bad_poses: 0,        // use to detect bad stretch of frames


    // event coordination
    validate_passed: null,      // do not write session until receive record validation
    make_record_public: null,   // user allows record to be published
	wakeup_db_event: null,		// inter-thread comm for bucket store events
	finished_event: null,	// inter-thread comm for all db write complete
	summary_event: null,	// inter-thread comm for perf summary is ready
	version_event: null,	// detect new app version from service worker
	system_ready_event: null,	// everything ready, entering <Menu>
	session_close_event: null,	// loop auto-detected an end, use this to inform UI
	show_target_cone_event: null,	// allow display of <div> in react
	show_warning_event: null,		// low level trigged show system message (eg. "no webcam")
	health_light_event: null,		// low level trigged show health light
	check_login_event: null,		// low level sleep and then check login
	get_redirect_event: null,		// low level auth get redirect after login (need both)
	login_event: null,		        // low level detected login
	logout_event: null,		        // low level detected logout
	has_news_event: null,		          // got news to display
    has_user_state_event: null,     // after user state loaded from db
    install_pwa_event: null,        // NOT USED: to prompt the android user to add to home screen
    gesture_detected_event: null,   // webcam detection

    pwa_install_state: null,        // remember from index

    // ready states
	history_ready: null,	// set after storing history to bucket
	video_ready: null,	// set after storing video to bucket
	console_ready: null,	// set after storing console.log to bucket

	// move these to timer?
	timer_display: 0,	// perf timer result
	ptimer_display: 0,	// perf phantom timer result
	timer_cnt: 0,		// number of frames to show perf result
	no_cone_cnt: 0,		// number of cumulative "no cone" frames
	cancel_cnt: 0,		// number of times at home to signal a stop

	// calibration related
    cam_ground_mode: "ground",  // webcam ground mode [ground, tripod, wall]
    pose_top: null,     // pose top in % of screen
    pose_bot: null,     // pose bottom in % of screen
    pose_ctr: null,     // pose center_y in % of screen
	calibrate_cnt: 0,	// number times detected calibration, need 2 (front & back)
	has_calibration: false,	// femur calibration (stand by cone) has completed
	disable_calibration: null,	// wait until player is ready
	calib_xx: 0,			// calibration spot
	calib_yy: 0,			// calibration spot
	calib_ww: 0,			// calibration spot
	calib_hh: 0,			// calibration spot
	cone_dy: 0,			// universal range if not set "per cone"
	cone_y: 0,			// universal Y if we need to scale down

	// home pad related
	home_id: null,		// home cone id, need to use getConeByID() to get cone
	home_x: 0,			// player return zone 
	home_y: 0,
	home_xsize: 0,		// size of the homing zone
	home_ysize: 0,


	// finger game setting related
	game_canvas_w: 0,
	game_canvas_h: 0,
	game_schemes: [],		// the different target moving scheme for each round
	game_scheme: {},		// current scheme
	game_scheme_idx: 0,		// current active scheme idx
	game_screen: {},		// canvas dimension {x, y}

	// finger game ops related
	game_press_valid: false,	// must keep finger on screen to measure reaction time
	game_press_cnt: 0,		// number of touches detected (both hit and miss)
	game_rounds: 0,			// number of rounds
	game_target: [],		// animate target object, tartet object
	game_animate: [],		// animate target object, animate event
	game_ex_target: [],		// keep around to hide it (do we need this?)
    max_reps: null,         //

	//game_fingers_down: 0,		// number of simultaneous presses
	//game_target_x: [],
	//game_target_y: [],
	//game_last_x: [],		// previous target, need for hiding
	//game_last_y: [],


    // game footage simulation related
	mock_type: null,		// [anaylsis, train, target] for game simulation
	mock_create_type: null,		// [anaylsis, train, target] for game simulation
	mock_show_timer: false,		// 
	mock_start_time: null,		// 
    mock_debug: false,      // dynamic debug with easter egg btn (bot right corner)
    mock_edit_mode: false,      // creating new sequences
    mock_display: 0,     // which buffer to display, use dual buffer for smooth animation

	//mock_targets: [],		// for analysis mode
	mock_schemes: [],		// the different target moving scheme for each round
	mock_scheme: {},		// current scheme
	mock_scheme_idx: 0,		// current active scheme idx

    // footage simulation related
    mock_tot_footages: [],      // all footages from db
    mock_tot_detects: [],       // all detects from db
    mock_detects: [],           // array of detect instruction object templates (from db)
    mock_all_detects: [],       // save raw from db, has all types
    mock_execute: [],           // array of detect execusion (randomized)

    mock_session_running: false,   // cache to speed up processing
    mock_active_click: null,    // cache of current click, must reset
    mock_video_paused: false,   // cache to speed up processing
    mock_timing_start: null,   // start to time
    mock_video_seek: null,      // video seek time
    mock_timeline: null,        // cache of footage timeline
    mock_detect_time: null,        // video time of start of detecct
    mock_target_idx: null,     // index to mock_exec
    mock_footage_idx: null,     // index to mock_tot_footage[]

	mock_press_valid: false,	// 
	mock_press_cnt: 0,		// number of touches detected (both hit and miss)
	mock_rounds: 0,			// number of rounds
    mock_detect: null,          // active detect instruction object
    mock_stop_time: null,       // video time of click received
    mock_playing_speed: null,   // to convert video time to real time
    mock_video_id: null,        // for access detects in db
    mock_video_hash: null,        // for access detects in db
    mock_scale_x: null,        // for access detects in db
    mock_scale_y: null,        // for access detects in db

    // override config params
    prog_param1: {},               // prog param1, used to set bot pre-prog mode
    drill_param1: {},               // drill param1 converted to obj, set in processDrillItems()
    drill_param2: {},               // drill param1 converted to obj, set in processDrillItems()
    mock_custom_speed: null,    // MUST CLEAR: override for this drill
    mock_custom_leader: null,   // MUST CLEAR: override for timer drill
    mock_custom_cones: null,   // MUST CLEAR: override for timer drill
    ai_train_set: null,         // number of new drill for trainers to do for a set
    custom_min_loop_px: null,   // overridable min px for loop detection
    custom_min_loop_msec: null,     // min elapse time for a turn
    record_output: null,        // record game and mock output (for intro)

    // generate animated gif previews for drill
    gif_video_hash: null,       // for <Gif> from index.js
    gif_drill_key: null,        // for <Gif> from index.js
    drag_start_x: null,         // support <Catalog> drag
	sidebar_width: CONSTS.SIDEBAR_SMALL_WIDTH,	// pixel of <Results> sidebar

	// target cone related
	fake_cones: 0,		// last set of fake cones created
	target_idx: null,	// idx of current cone to reach
	target_x: 0,		// current target cone coord
	target_y: 0,
	cone_target_x: 0,	// non-phantom target coord
	cone_target_y: 0,
	active_goals: 0,	// number of working goals in this run
	perf_run_cnt: 0,	// number of runs so far

	target_start_dist: 0,	// pixel distance to target
	target_reacted: false,	// flag to only react once per session
	phantom_reacted: false,	// flag to only phantom react once per session
	phantom_reached: false,	// flag to only phantom reached once per parent trip
	//phantom_check: false, 			// whether we should check for phantom-reache, do it once per run

	// femur mapping to ft
	ref_y: CONSTS.FEMUR_REF_Y_SEED,			// global: reference Y location where the pixel_ratio is valid
	ref_femur: CONSTS.FEMUR_REF_SEED,		// global: smoothed reference femur length at ref_y
	ref_femur1: CONSTS.FEMUR_REF_SEED,		// global: backup only
	ref_femur0: CONSTS.FEMUR_REF_SEED,		// global: raw reference femur length at ref_y
	ratio_femur_y: CONSTS.FEMUR_RATIO_Y_SEED,		// global: slope of D-femur v D-Y, use to calc depth
	femur_bucket_size: 0,			// var: femur slop bucket size
    ratio_femur_y: 0,
    femur_home_px: null,    // perf: lock the femur length at Home, do not change for the run
    femur_px: null,         // raw px
    femur_bad_count: 0,     // track to reset in case there is a valid big jump
    pixel_ratio: null,      // replacing STATS
    height_inch: null,      // player height in inches
	min_dy: 2,			    // var: filter min DY for femur-dy calc
    has_full_body: null,    // entire body is in the frame
};

// milestone timestampes
//
export var TIMES = {
	app_entry: 0,		// app entry 
	ai_start: 0,		// app entry 
	ai_loaded: 0,		// AI loaded
	webcam_start: 0,	// webcam starting
	webcam_stop: 0,		// webcam stopping
	start_run: 0,		// start of the signal
	start_run0: 0,		// backup of start of the signal (for Defender special case of late detect)
	start_timer_run: 0,	// start of the signal for timer-based
	player_moving: 0,	// after signal, time to move from zero to something
	player_moving1: 0,	// clone for display
	start_phantom: 0,	// perf: start of the phantom signal
	phantom_moving: 0,	// perf: after signal, time to move from zero to something
	reached_2femur: 0,	// defender: time takes to reach 3 femur distance
	session_start: 0,	// start of session when calibrated and reached center
	session_stop: 0,	// end of session
    inference_started: null,   // start of current analyzeImage()
    inference_completed: null,   // end of current analyzeImage(), to detect overlap

	// game timing
	game_show_target: [],	// high perf time, target displayed
	game_reacted: [],		// finger lifted (cognition)
	game_end_target: [],		// finger landed back on screen
	game_perf_react: [],	// array of reaction time
	game_perf_good: [],	// array of hit target perf times
	game_perf_bad: [],	// array of miss target perf times

	// simulation timing
	mock_show_target: [],	// high perf time, target displayed
	mock_reacted: [],		// finger lifted (cognition)
	mock_end_target: [],	// finger landed back on screen
	mock_perf_react: [],	// array of reaction time
	mock_perf_good: [],	// array of hit target perf times
	mock_perf_bad: [],	// array of miss target perf times

	// short term stuff
	timer_detect_stop: 0,	// detect stop event
	timer_stop_display: 0,	// detect stop event
	timer_restart_cooldown: 0,		// time before new session can start
	current_frame: 0,	// for this frame
	per_frame_time: 0,	// msec per frame
	fps_time: 0,		// tmp for FPS calc
}


// session global statatistics
//
export var STATS = {
	version: CONSTS.AXOS_DATA_VERSION,
    tot_frames: 0,
    no_balls: 0,        // none recognized
    no_ball3: 0,        // 3 conseq no ball
    no_ball6: 0,        // 4 conseq no ball
    bad_balls: 0,       // too big or wrong place
    sad_balls: 0,       // ball not round shape
    has_balls: 0,      // good confidence ball frames but may be inaccurate
    no_poses: 0,        // none recognized
    bad_poses: 0,       // low confid
    has_poses: 0,       // has a pose but could be inaccurate

    no_nothing: 0,      // has no ball nor pose, do not count these
	no_ball_cnt: 0,		// has no ball
	ball_touch_cnt: 0,		// number of ball touches
	pose_turn_cnt: 0,		// number of body turns
	pose_sess_turn_cnt: 0,		// number of body turns in session

	valid_femur_m_cnt: 0,	// valid femur slope, use to determine valid femur
	malform_m: 0,		// bad femur slope


	// key session performance (all time are in msec)
    //     - rXX:  Reaction time (from stimulus to action)
    //     - cXX:  Change of Direction time (from stop to new direction)
    //     - aXX:  accuracy
    //     - hXX:  heads up time (%)
    //     - dXX:  avg distance to ball
    //     - tXX:  time duration
    //     - ttX:  total overall time duration
    //
	//        ****** MUST ADD TO object: CONSTS.PERF_KEYS !!!! *****
	//        ****** MUST ADD TO Learn: updateDrillSummary() !!!! *****
	//        ****** MUST ADD TO performance: populateSTATSSummary() !!!! *****
	//        ****** MUST ADD TO server:  valid_leader_board_target() !!!! *****
	//        ****** MUST ADD TO server:  valid_perf_field() !!!! *****
	//        ****** MUST ADD TO server:  limit_record_value() !!!! *****
	//        ****** MUST ADD TO server:  low_target_field_type() !!!! *****
    //
	// PERF_KEYS: [ "r00", "r01", "r02", "r03", "r04", "r05", "tt0", ... ], 	 // **** MUST MATCH STATS!!!!
	//

    // CHALLENGE (PERF) - Cognition time from rest
    //
	r00: 0,			// avg reaction time1 (msec): direct 0 to 20% - for Challenge
	r00_cnt: 0,
	r01: 0,			// avg reaction time2 (msec): mid-turn redirect 0 to new-20% - for Challenge
	r01_cnt: 0,

	a00: 0,			// accuracy0 %: follow routine measured by turns (0..100)
	a00_cnt: 0,
	a01: 0,			// accuracy0 %: follow routine measured by turns (0..100)
	a01_cnt: 0,


    // DEFENDER - Change of direction acceleration
    //
	c01: 0,			// travel time2 (msec): redirect 0 to new-20% - for Challenge
	c01_cnt: 0,
	c02: 0,			// travel time1 (msec): from rest to reach 3-femur distance (chg-of-dir)
	c02_cnt: 0,


    // GAME - Cognition to lift finger
    //
	r04: 0,			// avg game reaction time4 (msec): staionary target - for game
	r04_cnt: 0,
	a04: 0,			// accuracy4 %: game stationary target accuracy
	a04_cnt: 0,	


    // MOCK - Cognition of game situation
    //
	r05: 0,			// avg game reaction time4 (msec): staionary target - for game
	r05_cnt: 0,
	a05: 0,			// accuracy4 %: game stationary target accuracy
	a05_cnt: 0,	


    // PRACTICE (SKILL, COND) - Overall loop duration
    //
	t00: 0,			// total session time (sec) - for practice sessions
	t00_cnt: 0,
	h00: 0,			// head up %: frames with head up - practice
	h00_cnt: 0,	

	t01: 0,			// avg per loop time (sec)
	t01_cnt: 0,



    // ALL
    //
	ss0: 0,			// total session score 
	ss0_cnt: 0,

	tt0: 0,			// total history time - use this for point calc - ALL
	tt0_cnt: 0,


    // UNUSED
    //
	d00: 0,			// distance0: avg distance to ball
	d00_cnt: 0,
	d01: 0,			// distance1: 
	d01_cnt: 0,
};  	


export var RUNS = [];		// run related info
export var PTURNS = [];		// turn related 
export var BTURNS = [];
export var CONES = [];		// cone base object for initialization



/*
 * instantiate new object from template
 * returns writable object
 */
export function CloneObject(obj) {
     var obj_str = JSON.stringify(obj);
     var new_obj = JSON.parse(obj_str);
     return new_obj;
}

export function initCONES(from) {
    //console.log("reset_cones.1113:   ! ! ! ! ! ! ! ! CONES[] GOT RESET!")
	CONES = [];
}

export function clearRUNS() {
    RUNS = [];
}

export function clearTURNS() {
    PTURNS = [];
    BTURNS = [];
}

export function initHistory() {
	HISTORY = [];
}

export function initCONSLOG() {
	CONSLOG = [];
}


var oldLog = console.log;
var oldError = console.error;


// redirect console.log into 
//
// src: https://superuser.com/questions/1417985/capture-console-log-to-a-file
export function storeConsoleLog() {
    var conslog = CONSLOG;
	(function() {
		//var oldLog = console.log;
		//var oldError = console.error;

		console.log = function (message) {
			var time = (Date.now() - TIMES.app_entry) / 1000;
			CONSLOG += time+": "+Array.prototype.join.call(arguments, ' ') + '\n';
			oldLog.apply(console, arguments);
		};

		console.error = function (message) {
			var time = (Date.now() - TIMES.app_entry) / 1000;
			CONSLOG += time+": ERROR-ERROR-ERROR-ERROR "+Array.prototype.join.call(arguments, ' ') + '\n';
			oldError.apply(console, arguments);
		};
	})();
}

// store direct into CONSLOG
export function console_log()  {

    var args = arguments;
    var time = (Date.now() - TIMES.app_entry) / 1000;
    CONSLOG += time+": "+Array.prototype.join.call(arguments, ' ') + '\n';
    oldLog.apply(console, arguments);
}